import React from "react";

type Props = {
  className?: string;
};

const EmptyTaskStatusIcon: React.FC<Props> = ({className}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="307"
    height="100"
    viewBox="0 0 307 100"
    fill="none"
    className={className}
  >
    <rect
      x="23.6938"
      y="31.0986"
      width="254.618"
      height="61.3375"
      rx="15.7276"
      fill="#F5F5F5"
    />
    <rect
      x="40.4586"
      y="65.6982"
      width="214.801"
      height="11.0093"
      rx="5.50464"
      fill="#CCDCF7"
    />
    <path
      d="M259.245 69.265C259.245 68.8058 259.377 68.4472 259.641 68.1892C259.912 67.925 260.258 67.7929 260.679 67.7929C261.101 67.7929 261.444 67.925 261.708 68.1892C261.978 68.4472 262.114 68.8058 262.114 69.265C262.114 69.7242 261.978 70.086 261.708 70.3502C261.444 70.6144 261.101 70.7465 260.679 70.7465C260.258 70.7465 259.912 70.6144 259.641 70.3502C259.377 70.086 259.245 69.7242 259.245 69.265ZM265.001 67.9156L261.236 74.4834H260.179L263.944 67.9156H265.001ZM260.679 68.444C260.283 68.444 260.085 68.7177 260.085 69.265C260.085 69.8186 260.283 70.0954 260.679 70.0954C260.868 70.0954 261.013 70.0294 261.113 69.8972C261.22 69.7588 261.274 69.5481 261.274 69.265C261.274 68.7177 261.076 68.444 260.679 68.444ZM263.086 73.1245C263.086 72.6653 263.218 72.3067 263.482 72.0488C263.752 71.7846 264.098 71.6524 264.52 71.6524C264.935 71.6524 265.275 71.7846 265.539 72.0488C265.81 72.3067 265.945 72.6653 265.945 73.1245C265.945 73.5838 265.81 73.9455 265.539 74.2097C265.275 74.474 264.935 74.6061 264.52 74.6061C264.098 74.6061 263.752 74.474 263.482 74.2097C263.218 73.9455 263.086 73.5838 263.086 73.1245ZM264.51 72.3036C264.114 72.3036 263.916 72.5772 263.916 73.1245C263.916 73.6719 264.114 73.9455 264.51 73.9455C264.907 73.9455 265.105 73.6719 265.105 73.1245C265.105 72.5772 264.907 72.3036 264.51 72.3036Z"
      fill="#CCDCF7"
    />
    <rect
      x="40.4586"
      y="46.8252"
      width="99.9568"
      height="11.0093"
      rx="5.50464"
      fill="#E0E0E0"
    />
    <path
      d="M146.081 50.3939C146.081 49.9347 146.213 49.5761 146.477 49.3181C146.748 49.0539 147.094 48.9218 147.515 48.9218C147.937 48.9218 148.28 49.0539 148.544 49.3181C148.814 49.5761 148.95 49.9347 148.95 50.3939C148.95 50.8531 148.814 51.2149 148.544 51.4791C148.28 51.7433 147.937 51.8754 147.515 51.8754C147.094 51.8754 146.748 51.7433 146.477 51.4791C146.213 51.2149 146.081 50.8531 146.081 50.3939ZM151.837 49.0445L148.072 55.6123H147.015L150.78 49.0445H151.837ZM147.515 49.5729C147.119 49.5729 146.921 49.8466 146.921 50.3939C146.921 50.9475 147.119 51.2243 147.515 51.2243C147.704 51.2243 147.849 51.1583 147.949 51.0261C148.056 50.8877 148.11 50.677 148.11 50.3939C148.11 49.8466 147.912 49.5729 147.515 49.5729ZM149.922 54.2534C149.922 53.7942 150.054 53.4356 150.318 53.1777C150.588 52.9135 150.934 52.7813 151.356 52.7813C151.771 52.7813 152.111 52.9135 152.375 53.1777C152.646 53.4356 152.781 53.7942 152.781 54.2534C152.781 54.7127 152.646 55.0744 152.375 55.3386C152.111 55.6029 151.771 55.735 151.356 55.735C150.934 55.735 150.588 55.6029 150.318 55.3386C150.054 55.0744 149.922 54.7127 149.922 54.2534ZM151.346 53.4325C150.95 53.4325 150.752 53.7061 150.752 54.2534C150.752 54.8008 150.95 55.0744 151.346 55.0744C151.743 55.0744 151.941 54.8008 151.941 54.2534C151.941 53.7061 151.743 53.4325 151.346 53.4325Z"
      fill="#E0E0E0"
    />
    <circle
      cx="7.57313"
      cy="71.5953"
      r="5.89783"
      stroke="#82B1FF"
      strokeWidth="1.57276"
    />
    <circle
      cx="241.217"
      cy="14.3142"
      r="4.71827"
      stroke="#82B1FF"
      strokeWidth="1.57276"
    />
    <circle
      cx="70.2174"
      cy="12.3142"
      r="4.71827"
      fill="#E0E0E0"
      stroke="#E0E0E0"
      strokeWidth="1.57276"
    />
    <rect
      x="163.645"
      y="0.178711"
      width="1.57276"
      height="9.43653"
      rx="0.786378"
      fill="#E3F2FD"
    />
    <rect
      x="169.149"
      y="4.11035"
      width="1.57276"
      height="9.43653"
      rx="0.786378"
      transform="rotate(90 169.149 4.11035)"
      fill="#E3F2FD"
    />
    <rect
      x="290.032"
      y="18.8096"
      width="1.57276"
      height="9.43653"
      rx="0.786378"
      fill="#E3F2FD"
    />
    <rect
      x="295.537"
      y="22.7412"
      width="1.57276"
      height="9.43653"
      rx="0.786378"
      transform="rotate(90 295.537 22.7412)"
      fill="#E3F2FD"
    />
    <rect
      x="7.17993"
      y="26.376"
      width="1.57276"
      height="9.43653"
      rx="0.786378"
      fill="#E3F2FD"
    />
    <rect
      x="12.6846"
      y="30.3076"
      width="1.57276"
      height="9.43653"
      rx="0.786378"
      transform="rotate(90 12.6846 30.3076)"
      fill="#E3F2FD"
    />

    <circle
      cx="300.606"
      cy="60.3689"
      r="4.71827"
      fill="#E0E0E0"
      stroke="#E0E0E0"
      strokeWidth="1.57276"
    />
  </svg>
);

export default EmptyTaskStatusIcon;
